import ComponentPlaceholder from 'components/ComponentPlaceholder';
import { LayoutContainer } from 'components/Layout';
import { getValidSitecoreLink, ScButton } from 'components/SitecoreLink';
import SwipeWrapper from 'components/SwipeWrapper';
import Text from 'components/Text';
import type { Field, SitecoreBlockProps, SitecoreLink } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic';
import { cn } from 'utils/classNames';
import { is } from 'utils/helpers';

interface Props extends SitecoreBlockProps {
	fields?: {
		heading?: Field<string>;
		isCarousel?: Field<boolean>;
		links?: SitecoreLink[];
	};
}

export default function Links({ fields, params }: Props) {
	if (!fields) {
		return null;
	}

	const { heading } = fields;
	const headingLevel = params?.heading || 'h2';
	const isCarousel = Boolean(fields.isCarousel?.value);
	const links = fields.links
		?.map((link) => getValidSitecoreLink(link))
		.filter(is.truthy);
	const hasLinks = is.arrayWithLength(links);

	if (!hasLinks) {
		return (
			<ComponentPlaceholder
				componentName="Links"
				className={getEditorMargin(params)}
				description="Requires valid links"
			/>
		);
	}

	return (
		<LayoutContainer
			id={params?.anchor}
			outerClassName={getEditorMargin(params)}
		>
			<Text as={headingLevel} field={heading} className="mb-4" />
			<SwipeWrapper
				activeClassName={cn(isCarousel && 'md:hidden', !isCarousel && 'hidden')}
				inactiveClassName={cn(
					'flex flex-wrap gap-4',
					isCarousel && 'max-md:hidden',
				)}
				pullGutters
			>
				{links.map((link) => (
					<li key={`${link.href}-${link.text}`}>
						<ScButton link={link} trailingIcon="arrow-forward">
							{link.text}
						</ScButton>
					</li>
				))}
			</SwipeWrapper>
		</LayoutContainer>
	);
}
Links.displayName = 'Links';
